import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

// Import all pages
import HomePage from './pages/HomePage';
import HorasTrabalhadasPage from './pages/HorasTrabalhadasPage';
import HorasExtrasPage from './pages/HorasExtrasPage';
import SubtracaoPage from './pages/SubtracaoPage';
import BancoHorasPage from './pages/BancoHorasPage';
import AdicionalNoturnoPage from './pages/AdicionalNoturnoPage';
import CalculadoraTempoPage from './pages/CalculadoraTempoPage';
import CalculoHorasExtraordinariasPage from './pages/CalculoHorasExtraordinariasPage';
import AdicionalNoturnoValorPage from './pages/AdicionalNoturnoValorPage';
import ConverterHorasDiasPage from './pages/ConverterHorasDiasPage';
import ContadorHorasPage from './pages/ContadorHorasPage';
import JornadaTrabalhoPage from './pages/JornadaTrabalhoPage';
import CalculadoraMinutosPage from './pages/CalculadoraMinutosPage';
import BancoHorasComoFuncionaPage from './pages/BancoHorasComoFuncionaPage';
import CalculoHoraTrabalhada from './pages/CalculoHoraTrabalhada';
import AdicionalNoturnoHorarioPage from './pages/AdicionalNoturnoHorarioPage';
import QuantasHorasExtrasPage from './pages/QuantasHorasExtrasPage';
import SobrePage from './pages/SobrePage';
import PrivacidadePage from './pages/PrivacidadePage';
import ContatoPage from './pages/ContatoPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  // Load AdSense Auto Ads AFTER the initial React hydration commit.
  // If this script is injected in <head> (even async), it races with hydrateRoot
  // on warm-cache visits: AdSense executes, injects <ins class="adsbygoogle"> into
  // #root before React has finished walking the prerendered DOM, and triggers
  // React error #418 and a full DOM remount that removes the ad.
  // useEffect fires after the first render/hydration commit, eliminating that race.
  // The ReactSnap guard prevents this from executing during react-snap prerendering.
  useEffect(() => {
    if (navigator.userAgent === 'ReactSnap') return;
    if (document.querySelector('script[src*="adsbygoogle.js"]')) return;
    const script = document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2505220415920221';
    document.head.appendChild(script);
  }, []);

  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-light-bg lg:pl-56 pb-16 lg:pb-0">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />

            {/* Calculator tool pages */}
            <Route path="/calculadora-de-horas-trabalhadas" element={<HorasTrabalhadasPage />} />
            <Route path="/calculadora-de-horas-extras" element={<HorasExtrasPage />} />
            <Route path="/calculadora-de-subtracao-de-horas" element={<SubtracaoPage />} />
            <Route path="/calculadora-de-banco-de-horas" element={<BancoHorasPage />} />
            <Route path="/calculadora-de-adicional-noturno" element={<AdicionalNoturnoPage />} />
            <Route path="/calculadora-de-tempo" element={<CalculadoraTempoPage />} />
            <Route path="/calculadora-de-minutos" element={<CalculadoraMinutosPage />} />
            <Route path="/contador-de-horas" element={<ContadorHorasPage />} />

            {/* Guide / informational pages */}
            <Route path="/calculo-de-horas-extraordinarias" element={<CalculoHorasExtraordinariasPage />} />
            <Route path="/adicional-noturno-valor" element={<AdicionalNoturnoValorPage />} />
            <Route path="/converter-horas-em-dias" element={<ConverterHorasDiasPage />} />
            <Route path="/jornada-de-trabalho" element={<JornadaTrabalhoPage />} />
            <Route path="/banco-de-horas-como-funciona" element={<BancoHorasComoFuncionaPage />} />
            <Route path="/calculo-de-hora-trabalhada" element={<CalculoHoraTrabalhada />} />
            <Route path="/adicional-noturno-horario" element={<AdicionalNoturnoHorarioPage />} />
            <Route path="/quantas-horas-extras-por-dia" element={<QuantasHorasExtrasPage />} />

            {/* Legacy URL redirects */}
            <Route path="/horas-trabalhadas" element={<Navigate to="/calculadora-de-horas-trabalhadas" replace />} />
            <Route path="/horas-extras" element={<Navigate to="/calculadora-de-horas-extras" replace />} />
            <Route path="/subtracao" element={<Navigate to="/calculadora-de-subtracao-de-horas" replace />} />
            <Route path="/banco-de-horas" element={<Navigate to="/calculadora-de-banco-de-horas" replace />} />
            <Route path="/adicional-noturno" element={<Navigate to="/calculadora-de-adicional-noturno" replace />} />
            <Route path="/calculadora-de-horas" element={<Navigate to="/" replace />} />

            <Route path="/sobre" element={<SobrePage />} />
            <Route path="/politica-privacidade" element={<PrivacidadePage />} />
            <Route path="/contato" element={<ContatoPage />} />

            {/* Catch-all: any unmatched path → 404 */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
